import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { AssetsViewRoutes } from '../../../routes';

export const AssetsLayout = () => <SwitchRoute routes={AssetsViewRoutes} />;
